<a
	class="link" 
	*rxLet="route$; let route" 
	[routerLink]="route.path "
	routerLinkActive="active"
	title="{{ route.title }}"
	matRipple
	>
	<span class="label">
		{{ route.title }}
		<span class="under-line-container"></span>
	</span>
</a>
